module.exports = __webpack_public_path__ + "static/media/12.90d438bd.jpg";